module.exports = __webpack_public_path__ + "img/dynamic.ea9910b1.svg";